// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar-module--sidebar--31uFS","menuList":"Sidebar-module--menuList--2hPot","active":"Sidebar-module--active--AmL6r","socialList":"Sidebar-module--socialList--3qgzF"};